export default __webpack_public_path__ + "static/media/correct7.946bb702.mp3";